import { defaultUiConfig } from "~config/sport/defaultsUi";
import type { UiConfiguration } from "~types/uiConfiguration";

export const basketballUiConfig: UiConfiguration = {
  ...defaultUiConfig,
  pages: {
    ...defaultUiConfig.pages,
    entityStatistic: { enabled: true },
  },
};
